import { createAction } from '@reduxjs/toolkit';

export const careProvidedAtChbChange = createAction('[CareProvidedAtReceivingFacility] careProvidedAtChbChange');
export const careProvidedAtDescChange = createAction('[CareProvidedAtReceivingFacility] careProvidedAtDescChange');
export const loseETA = createAction('[CareProvidedAtReceivingFacility] loseETA');
